import type React from "react";

export function Section({ heading, children }: { heading?: string; children: React.ReactNode }) {
  return (
    <section className="space-y-2">
      {heading && (
        <h3 className="px-4 text-[15px] uppercase tracking-[0.06em] font-semibold text-slate-500">
          {heading}
        </h3>
      )}
      {children}
    </section>
  );
}

export function GroupedCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded-2xl bg-white border border-slate-200/70 overflow-hidden shadow-[0_0.5px_0_rgba(0,0,0,0.04)]">
      {children}
    </div>
  );
}

export function Row({
  label,
  value,
  mono,
  last,
}: {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
  last?: boolean;
}) {
  return (
    <div
      className={`flex items-center gap-4 px-4 min-h-[44px] py-2.5 ${
        last ? "" : "border-b border-slate-200/80"
      }`}
    >
      <span className="text-[17px] text-slate-500 shrink-0">{label}</span>
      <span
        className={`ml-auto text-[17px] text-slate-900 text-right min-w-0 ${
          mono ? "font-mono tabular-nums tracking-tight" : ""
        }`}
      >
        {value}
      </span>
    </div>
  );
}
